import { theme } from "@lvt/material";
import { createTheme, makeStyles } from "@material-ui/core";


export const useStyles = makeStyles({
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(10, 10%)",
        gridTemplateRows: "auto",
        padding: "20px 5% 0.5em 5%",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
    },
    note: {
        gridColumn: "1 / 3",
        gridRow: "1 / 3",
        paddingRight: "2em",
        fontSize: 16,
        color: theme.palette.grey[700],
    },
    inputs: {
        gridColumn: "3 / 13",
        gridRow: "1",
        display: "flex",
        alignItems: "start",
        height: "4.75em",
    },
    requestVideo: {
        height: 32,
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
        boxShadow: "none",
        textTransform: "capitalize",
        "&:hover": {
            backgroundColor: theme.palette.info.light,
            boxShadow: "none",
        },
    },
    requestVideoSpan: {
        margin: "0.5em 0 0 auto",
    },
    dotAndDate: {
        display: "flex",
        alignItems: "center",
        marginTop: "7px",
        "& p": {
            color: theme.palette.grey[700],
        },
    },
    dot: {
        height: 8,
        width: 8,
        borderRadius: "100%",
        marginRight: "0.5em",
    },
    timeline: {
        gridColumn: "3 / 13",
        gridRow: "2",
    },
    warning: {
        padding: "0px 0px",
        margin: "0px 0px",
        color: theme.palette.error.main,
        textAlign: "center",
    },
});

export const pickerStyles = createTheme({
    palette: {
        primary: theme.palette.primary,
        secondary: theme.palette.secondary,
    },
    overrides: {
        MuiFormLabel: {
            root: {
                padding: "0.5em 1em",
                font: `${theme.typography.caption}`,
            },
        },
        MuiFormControl: {
            root: {
                width: "12em",
                marginRight: "1em",
                borderRadius: "4px 4px 0 0",
                backgroundColor: theme.palette.grey[100],
            },
        },
        MuiInputBase: {
            input: {
                font: `${theme.typography.body2}`,
                padding: "0.5em 0 0.5em 1em",
            },
        },
        MuiInput: {
            underline: {
                "&:before": {
                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                },
            },
        },
        MuiInputAdornment: {
            positionEnd: {
                marginBottom: "16px",
            },
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: theme.palette.secondary.dark,
                "&:hover": {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
        },
        MuiPickersClockPointer: {
            thumb: {
                borderColor: theme.palette.secondary.dark,
            },
            noPoint: {
                backgroundColor: theme.palette.secondary.dark,
            },
        },
    },
});

export const tzStyle = createTheme({
    overrides: {
        MuiFormLabel: {
            root: {
                padding: "0.5em 1em",
                font: `${theme.typography.caption}`,
            },
        },
        MuiInputBase: {
            input: {
                font: `${theme.typography.body2}`,
                padding: "0.5em 0 0.5em 1em",
            },
        },
        MuiInput: {
            underline: {
                "&:before": {
                    content: "none",
                },
            },
        },
    },
});
